<template>
  <div class="guide-pop">
    <van-popup v-model="show" :close-on-click-overlay="false" :round="isTips" :closeable="isTips" @close="close" get-container="body">
      <div class="content" v-if="isTips">
        <div class="title">新版本指引</div>
        <div class="text">全新的创建活动已经上线，点击“去了解”可查看详情</div>
        <div class="btn-box">
          <div class="btn-item" @click="close">跳过</div>
          <div class="btn-item active" @click="guide">去了解</div>
        </div>
        <van-checkbox class="checkbox" checked-color="#FF6B31" v-model="checked">不在提示</van-checkbox>
      </div>
      <div class="guide-box" v-else>
        <van-image
          width="100vw"
          height="100vh"
          class="img"
          :src="imgList[currentIndex]"
        />
        <div class="btn" :style="btnObj" @click="nextStep"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      show: false,
      isTips: true,
      imgList: [
        'https://img3.quanyou.com.cn/joyNew/group1/M00/1F/87/rB8LrmVJ2GKAPnMXAAeuhJ_xVYw938.png',
        'https://img3.quanyou.com.cn/joyNew/group1/M00/1F/89/rB8LrmVJ3-KAERVFAAdfFuU5gSM301.png',
        'https://img3.quanyou.com.cn/joyNew/group1/M00/1F/8A/rB8LrWVJ4AGALcmAAAdlDi8N9Cc849.png'
      ],
      currentIndex: 0,
      checked: false,
    }
  },
  computed: {
    ...mapGetters([
      'isTeacher',
      'isDistributor',
      'isShopowner',
      'isGuide'
    ]),
    btnObj() {
      if (this.currentIndex == 0) {
        return {
          top: '16vh',
          right: '20vw'
        }
      } else if(this.currentIndex == 1) {
        return {
          top: '21vh',
          right: '22vw'
        }
      } else {
        return {
          top: '21vh',
          right: '6vw'
        }
      }
    },
    // 来源
    source() {
      return this.$route.query.tmpId 
    },
  },
  mounted() {
    this.getPopupInfo()
  },
  methods: {
    nextStep() {
      if (this.currentIndex == 2) {
        this.show = false
      } else {
        this.currentIndex++
      }
    },
    getPopupInfo() {
      if (this.isGuide || !this.source) return
      this.$api.h5.getPopupInfo().then(res => {
        if (res.success) {
          const {boolShow} = res.data
          this.show = JSON.parse(boolShow)
        }
      })
    },
    setPopup() {
      if (this.checked) {
        this.$api.h5.setPopup()
      }
     
    },
    close() {
      this.show = false
      this.setPopup()
    },
    guide() {
      this.isTips = false
      this.setPopup()
    }
  }
}
</script>

<style lang="stylus" scoped>
  .content {
    width: 331px;
    // height: 205px;
    padding: 20px;
    background: #FFFFFF;
    box-sizing: border-box;
    .title {
      font-size: 17px;
      color: #333333;
      font-weight: bold;
      text-align: center;
    }
    .text {
      color: #333333;
      font-size: 15px;
      font-weight: 400;
      line-height: 29px;
      margin-top: 15px;
    }
    .btn-box {
      display: flex;
      justify-content: space-between;
      margin-top: 30px;
      .btn-item {
        width: 140px;
        height: 44px;
        font-size: 17px;
        text-align: center;
        line-height: 44px;
        background: #E5E5E5;
        border-radius: 4px;
        font-weight: 500;
      }
      .active {
        color: #fff;
        background: linear-gradient(180deg, #FF8820 0%, #FF6B31 100%);
      }
    }
  }
  .checkbox {
    display: flex;
    justify-content: center;
    margin-top: 14px;
  }
  .guide-box {
    position: relative;
    .img {
      display: block;
    }
    .btn {
      position: absolute;
    
      width: 25vw;
      height: 8vh;
      opacity: 0;
    }
  }
</style>